import { useContextState } from '../../../hooks/theme'

export const useStyles = () => {
  const { colors: color } = useContextState()

  return ({
    closeSuccess: {         
      position: 'absolute',
      right: '26px',
      top: '16px',
    },
    buttonContainer: {       
      display: 'flex',
      justifyContent: 'end',
      padding:1,
    },
    containerSuccess: {  
      width: '100%',
      height:'100%',
      margin: 'auto',
      padding: '10px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      '& .container': {
        margin: '20px auto',
        width: '100%',
        padding: '10px',
        display: 'flex',
        flexDirection: 'column',
        flexGrow:1,
        gap: '30px',
      },
      '& .containarTitle':{
        display:'flex', 
        justifyContent:'center'
      },
      '& .MuiTypography-root': {
        width: 'fit-content',
        textAlign: 'center',
      },
      '& .continue': {
        color: 'white',
        backgroundColor: color.color4,
      },
      '& .subtitle': {
        fontSize:'14px',
        color: color.color9
      }
    },
    baseModal: {
      minWidth: '500px', 
      padding:2, 
      maxHeight: '90vh', 
      overflow: 'auto', 
      scrollbarWidth: 'none'
    }
  
  })
}
